import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
@Injectable()
export class OverallOtifService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  keys = [];
  yAxisKey = [];
  constructor(public generic: GenericHttpService) { }

  getOverallOtifData(url, params): Observable<any> {
    const option = {
      method: "GET",
      // url: `${this.apiUrl}${this.apiUrlConstant.getOverallOtif}`,
      url: url, // "./assets/data/p-d-otif.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processOverAllOTIF.bind(this))
    );
  }

  processOverAllOTIF(data: any) {
    const dataSets = data.data[0];
    this.keys = [];
    this.yAxisKey = [];
    for (const k in dataSets) {
      if (k) {
        this.keys.push(k);
      }
    }
    for (const k in dataSets) {
      if (k) {
        if (k.substring(0, 3) === "sla") {
          this.yAxisKey.push(
            k.substring(0, 3).toUpperCase() + k.slice(3).replace(/_|-/g, " ")
          );
        } else {
          this.yAxisKey.push(
            k[0].toUpperCase() + k.slice(1).replace(/_|-/g, " ")
          );
        }

      }
    }

    let startPoint = 0;
    //Check if Data is empty
    let total = 0;

    this.keys.map(key => {
      if (dataSets[key] > 0) {
        total += Number(dataSets[key]);
      }
    });

    if (total === 0) {
      return [];
    }
    const chartData = this.keys.map((value, i) => {
      const point = [];
      if (i === 0) {
        startPoint = Number((dataSets["sla_success"] - 10).toFixed(0)) > 10 ? Number((dataSets["sla_success"] - 10).toFixed(0)) : 0; //Number(dataSets["otif"].toFixed //(100 - (100 - dataSets["otif"]) * 2
        startPoint = Number((Math.floor(startPoint / 10) * 10).toFixed(2));
      }
      point.push(startPoint);
      if (i === dataSets.length) {
        startPoint = 100;
      } else if (i === 0) {
        startPoint = Number(dataSets[this.keys[i]].toFixed(2));
      } else {
        startPoint += Number(dataSets[this.keys[i]].toFixed(2));
        startPoint = Number(startPoint.toFixed(2));
      }
      point.push(startPoint);
      return point;
    });
    return chartData;
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.yAxis.min = chartData[0][0]; //100 - (100 - chartData[0][0]) * 2;
    chart.yAxis.max = 120;
    chart.series[0].data = chartData;
    chart.xAxis.categories = this.yAxisKey;
    return chart;
  }
}
